var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCgu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1672,
    height: 17236,
    viewBox: "0 0 1672 17236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5156",
    "data-name": "Group 5156",
    transform: "translate(-123 -230)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5154",
    "data-name": "Group 5154"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Mentions_l\\xE9gales",
    "data-name": "Mentions l\\xE9gales",
    transform: "translate(125 280)",
    fontSize: 50,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Mentions l\xE9gales")), /*#__PURE__*/React.createElement("text", {
    id: "EDITEUR_Hoo-Pow_Soci\\xE9t\\xE9_\\xE0_responsabilit\\xE9_limit\\xE9e_au_capital_de_12.000_00_euros_Enregistrement_en_cours_au_RCS_de_Luxembourg_Si\\xE8ge_social_:_3_rue_des_Girondins_L-1626_Luxembourg_HEBERGEMENT_Amazon_CS_Ireland_Ltd_Adresse_:_Unit_27_6400_Cork_Airport_Busin",
    "data-name": "EDITEUR Hoo-Pow Soci\\xE9t\\xE9 \\xE0 responsabilit\\xE9 limit\\xE9e au capital de 12.000,00 euros Enregistrement en cours au RCS de Luxembourg Si\\xE8ge social\\xA0: 3, rue des Girondins L-1626 Luxembourg HEBERGEMENT Amazon CS Ireland Ltd Adresse : Unit 27 \\u2013 6400 Cork Airport Busin",
    transform: "translate(125 320)",
    fontSize: 32,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 32
  }, "EDITEUR"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Avenir-Medium, Avenir",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 65
  }, "Hoo-Pow"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 98
  }, "Soci\xE9t\xE9 \xE0 responsabilit\xE9 limit\xE9e au capital de 12.000,00 euros"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 131
  }, "Enregistrement en cours au RCS de Luxembourg"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 164
  }, "Si\xE8ge social\xA0: 3, rue des Girondins"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 197
  }, "L-1626 Luxembourg"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 230
  })), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 263
  }, "HEBERGEMENT"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Avenir-Medium, Avenir",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 296
  }, "Amazon CS Ireland Ltd"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 329
  }, "Adresse : Unit 27 \u2013 6400 Cork Airport Business Park \u2013 Kinsale Road \u2013 Ireland"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 362
  }, "Amazon CS Ireland Ltd est une soci\xE9t\xE9 du groupe Amazon Web Services (AWS), dont le si\xE8ge social se situe \xE0 "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 395
  }, "Seattle, WA, USA, P.O. Box 81226 "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 428
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5155",
    "data-name": "Group 5155",
    transform: "translate(0 548)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Conditions_G\\xE9n\\xE9rales_d_Abonnement",
    "data-name": "Conditions G\\xE9n\\xE9rales d\\u2019Abonnement",
    transform: "translate(125 280)",
    fontSize: 50,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Conditions G\xE9n\xE9rales d\u2019Abonnement")), /*#__PURE__*/React.createElement("text", {
    id: "Les_pr\\xE9sentes_Conditions_G\\xE9n\\xE9rales_d_Abonnement_ci-apr\\xE8s_CGA_ont_pour_objectif_de_d\\xE9finir_les_conditions_dans_lesquelles_le_client_peut_souscrire_et_utiliser_le_service_HooPow_\\xE9dit\\xE9_et_propos\\xE9_par_Hoo-Pow_Soci\\xE9t\\xE9_\\xE0_responsabilit\\xE9_limit\\xE9e_au_capital",
    "data-name": "Les pr\\xE9sentes Conditions G\\xE9n\\xE9rales d\\u2019Abonnement (ci-apr\\xE8s \\xAB CGA \\xBB) ont pour objectif de d\\xE9finir les conditions dans lesquelles le client peut souscrire et utiliser le service HooPow, \\xE9dit\\xE9 et propos\\xE9 par Hoo-Pow, Soci\\xE9t\\xE9 \\xE0 responsabilit\\xE9 limit\\xE9e au capital",
    transform: "translate(125 320)",
    fontSize: 32,
    fontFamily: "Avenir-Medium, Avenir",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 32
  }, "Les pr\xE9sentes Conditions G\xE9n\xE9rales d\u2019Abonnement (ci-apr\xE8s \xAB CGA \xBB) ont pour objectif de d\xE9finir les conditions "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 65
  }, "dans lesquelles le client peut souscrire et utiliser le service HooPow, \xE9dit\xE9 et propos\xE9 par Hoo-Pow, Soci\xE9t\xE9 \xE0 "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 98
  }, "responsabilit\xE9 limit\xE9e au capital de 12.000,00 euros, dont l\u2019enregistrement est en cours aupr\xE8s du RCS de "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 131
  }, "Luxembourg et dont le si\xE8ge social est situ\xE9 03, rue des Girondins \u2013 L-1626 Luxembourg (ci-apr\xE8s \xAB HooPow \xBB)."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 164
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 197
  }, "Directeur de la publication : Nor\xE9dine ALLAM"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 230
  }), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 263
  }, "Article 1 : D\xE9finitions")), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 296
  }, "Dans les pr\xE9sentes CGA, les termes vis\xE9s ci-dessous auront la signification suivante :"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 329
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 362
  }, "\xAB Abonn\xE9 \xBB d\xE9signe toute personne physique majeure qui souscrit au moyen d\u2019une carte bancaire fran\xE7aise au "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 395
  }, "Service directement propos\xE9 par la soci\xE9t\xE9 HooPow, pour ses besoins propres ou les besoins d\u2019une autre "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 428
  }, "personne physique de son entourage \xE0 qui l\u2019Abonn\xE9 confie l\u2019utilisation du Service."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 461
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 494
  }, "\xAB Service \xBB d\xE9signe le service payant \xE9dit\xE9 par HooPow permettant \xE0 l\u2019Abonn\xE9 l\u2019acc\xE8s au contenu de plateforme "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 527
  }, "HooPow. Le Service est disponible uniquement en se connectant sur le Site et est r\xE9serv\xE9 \xE0 un usage strictement "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 560
  }, "priv\xE9."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 593
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 626
  }, "\xAB Date d\u2019activation \xBB d\xE9signe la date \xE0 partir de laquelle l\u2019Abonn\xE9 peut consommer le Service, soit d\xE8s l\u2019envoi de "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 659
  }, "l\u2019e-mail de confirmation de cr\xE9ation de son compte (ci-apr\xE8s d\xE9sign\xE9 le \xAB\xA0Compte\xA0\xBB)."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 692
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 725
  }, "\xAB Site \xBB : d\xE9signe le site Internet \xE9dit\xE9 par la soci\xE9t\xE9 HooPow, accessible \xE0 l\u2019adresse URL suivante : www.hoo-"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 758
  }, "pow.com, permettant de souscrire et d\u2019acc\xE9der au Service, y compris les pages du domaine hoo-pow.com."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 791
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 824
  }, "\xAB Territoire \xBB d\xE9signe la France m\xE9tropolitaine (Corse comprise)."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 857
  }, "\xAB\xA0Utilisateur\xA0\xBB d\xE9signe toute personne physique qui navigue sur le Site, y compris les Abonn\xE9s."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 890
  }), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 923
  }, "Article 2 : Objet")), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 956
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 989
  }, "Les pr\xE9sentes CGA ont pour objet de d\xE9finir les conditions dans lesquelles HooPow fournira sur le Territoire \xE0 "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1022
  }, "l\u2019Abonn\xE9, l\u2019acc\xE8s au Service sur les terminaux de r\xE9ception d\xE9finis \xE0 l\u2019article 3."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1055
  }, "L\u2019abonnement (ci-apr\xE8s l\u2019\xAB\xA0Abonnement\xA0\xBB) mis \xE0 disposition de l\u2019Abonn\xE9 lui donne acc\xE8s au Service exclusivement "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1088
  }, "depuis une tablette ou un ordinateur. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1121
  }, "En souscrivant au Service, l\u2019Abonn\xE9 reconna\xEEt express\xE9ment qu\u2019il a pris connaissance des CGA et qu\u2019il en accepte "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1154
  }, "l\u2019int\xE9gralit\xE9 des termes, sans aucune r\xE9serve."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1187
  }), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1220
  }, "Article 3 : Terminaux de r\xE9ception disponibles")), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1253
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1286
  }, "L\u2019activation du Service interviendra apr\xE8s la souscription, sous r\xE9serve d\u2019acceptation du paiement et du moyen de "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1319
  }, "paiement associ\xE9."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1352
  }, "Le Service est disponible sur les terminaux de r\xE9ception list\xE9s ci-dessous (ci-apr\xE8s d\xE9sign\xE9(s) les \xAB Terminaux \xBB et "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1385
  }, "individuellement le \xAB Terminal \xBB)."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1418
  }, "Pour acc\xE9der au Service, l\u2019Abonn\xE9 doit disposer d\u2019une connexion Internet avec un d\xE9bit suffisant, d\u2019\xE9quipement "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1451
  }, "disposant d\u2019une capacit\xE9 de m\xE9moire vive, de versions logicielles, et d\u2019un processeur compatible."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1484
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1517
  }, "HooPow vous informe que les syst\xE8mes permettant de masquer l\u2019adresse IP publique de son terminal, tels que "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1550
  }, "notamment les r\xE9seaux priv\xE9s virtuels (VPN) ou serveurs mandataires (\xE9galement appel\xE9s proxy) ne sont pas "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1583
  }, "support\xE9es nativement pour acc\xE9der au Service."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1616
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1649
  }, "3.1 Ordinateurs"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1682
  }, "Le Service est accessible via le Site, sous r\xE9serve d\u2019activer ses droits conform\xE9ment \xE0 la proc\xE9dure d\xE9crite sur le "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1715
  }, "Site, sur les appareils et/ou micro-ordinateurs (PC/Mac) utilisant les navigateurs web suivants :"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1748
  }, "Navigateurs PC Windows 10 :"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1781
  }, "Mozilla Firefox 64 ou versions ult\xE9rieures\xA0"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1814
  }, "Google Chrome 75 ou versions ult\xE9rieures"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1847
  }, "Internet Explorer (PC)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1880
  }, "compatibilit\xE9 avec EDGE"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1913
  }, "Navigateurs PC Windows 7 et Windows 8 :\xA0"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1946
  }, "Mozilla Firefox 64 ou versions ult\xE9rieures\xA0"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1979
  }, "Google Chrome 75 ou versions ult\xE9rieures"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2012
  }, "Navigateurs Mac :\xA0"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2045
  }, "Mozilla Firefox 64 ou versions ult\xE9rieures\xA0"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2078
  }, "Google Chrome 75 ou versions ult\xE9rieures"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2111
  }, "Safari 10.1.2 (implique macOS 10.10 en minimum) ou versions ult\xE9rieures."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2144
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2177
  }, "3.2 Equipements mobiles (tablettes)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2210
  }, "Le Service est accessible via le Site depuis tout r\xE9seau Internet (Wi-Fi, 3G/3G+/4G en France m\xE9tropolitaine "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2243
  }, "uniquement) sur les tablettes \xE9quip\xE9es :"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2276
  }, "(i) du syst\xE8me d\u2019exploitation iOS 10.0 ou versions ult\xE9rieures"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2309
  }, "(ii) du syst\xE8me d\u2019exploitation Android 5.0 ou versions ult\xE9rieures"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2342
  }, "(iii) du syst\xE8me d\u2019exploitation Windows 10 ou version ult\xE9rieures"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2375
  }, "Aucune garantie n\u2019est fournie quant \xE0 l\u2019acc\xE8s via mobile et ce quel que soit le syst\xE8me d\u2019exploitation."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2408
  }, "Pour un meilleur confort de visionnage, il est conseill\xE9 de privil\xE9gier le mode Wi-Fi. L\u2019utilisation du Service par les "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2441
  }, "r\xE9seaux mobiles EDGE/3G/4G peut entra\xEEner des surco\xFBts de communications li\xE9s \xE0 la consommation de bande "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2474
  }, "passante pour lesquels HooPow ne saurait \xEAtre tenue responsable."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2507
  }), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2540
  }, "Article 4 : Modalit\xE9s d\u2019utilisation du Service"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2573
  })), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2606
  }, "4.1 Souscription"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2639
  }, "La souscription du Service aupr\xE8s d\u2019HooPow peut \xEAtre effectu\xE9e depuis le Site dans les conditions d\xE9finies \xE0 "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2672
  }, "l\u2019article 3 ci-dessus. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2705
  }, "L\u2019Abonnement entre en vigueur \xE0 compter de la Date d\u2019activation."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2738
  }, "L\u2019identifiant et le mot de passe de l\u2019Abonn\xE9 sont personnels et confidentiels. L\u2019Abonn\xE9 s\u2019engage \xE0 ne pas les "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2771
  }, "divulguer et \xE0 prendre toutes les mesures n\xE9cessaires pour pr\xE9server cette confidentialit\xE9. En cons\xE9quence, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2804
  }, "l\u2019Abonn\xE9 sera responsable de toute activit\xE9 ou action sur son Compte."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2837
  }, "L\u2019Abonn\xE9 s\u2019engage \xE0 signaler toute utilisation non autoris\xE9e et/ou suspecte de son Compte en envoyant un mail \xE0 "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2870
  }, "l\u2019adresse suivante : BDouin(a)hoo-pow.com"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2903
  }, "La souscription au Service est r\xE9serv\xE9e aux personnes physiques domicili\xE9es sur le Territoire."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2936
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2969
  }, "4.2 Accessibilit\xE9 au Service"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3002
  }, "Le Service est r\xE9serv\xE9 \xE0 un usage strictement priv\xE9 et personnel ne pouvant s\u2019\xE9tendre au-del\xE0 du cercle de famille. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3035
  }, "Tout usage commercial du Service est strictement interdit."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3068
  }, "L\u2019abonn\xE9 est inform\xE9 que le Service donne acc\xE8s \xE0 un catalogue de vid\xE9ogrammes dont le contenu est susceptible "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3101
  }, "d\u2019\xE9volution. Le Service est accessible depuis la France m\xE9tropolitaine (Corse incluse). "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3134
  }, "En application du R\xC8GLEMENT (UE) 2017/1128 du 14 juin 2017 sur la portabilit\xE9 transfrontali\xE8re des services de "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3167
  }, "contenu en ligne, les Abonn\xE9s pourront, \xE0 compter du 1er avril 2018, acc\xE9der au Service lors de leur d\xE9placement "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3200
  }, "temporaire dans un autre Etat membre de l\u2019Union Europ\xE9enne (par exemple lors de leurs vacances ou voyages "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3233
  }, "d\u2019affaires), c\u2019est-\xE0-dire dans les territoires suivants : l&apos;Allemagne, l&apos;Autriche, la Belgique, la Bulgarie, Chypre, la "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3266
  }, "Croatie, le Danemark, l&apos;Espagne (les A\xE7ores et les \xCEles Canaries incluses), l&apos;Estonie, la Finlande, la France "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3299
  }, "m\xE9tropolitaine (Corse incluse, ainsi que les r\xE9gions p\xE9riph\xE9riques suivants : la Martinique, Mayotte, la Guadeloupe, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3332
  }, "la Guyane et la R\xE9union, Saint-Martin), la Gr\xE8ce, la Hongrie, l&apos;Irlande, l&apos;Italie, la Lettonie, la Lituanie, le "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3365
  }, "Luxembourg, Malte, les Pays-Bas, la Pologne, le Portugal (Mad\xE8re inclus), la R\xE9publique tch\xE8que, la Roumanie, la "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3398
  }, "Slovaquie, la Slov\xE9nie et la Su\xE8de (ci-apr\xE8s l\u2019\xAB Union Europ\xE9enne \xBB)."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3431
  }), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3464
  }, "Article 5 : Dur\xE9e de l\u2019Abonnement au Service"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3497
  })), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3530
  }, "L\u2019Abonnement est d\xE9clin\xE9 en plusieurs formules (ci-apr\xE8s les \xAB\xA0Formules\xA0\xBB et individuellement \xAB\xA0Formule\xA0\xBB)\xA0:"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3563
  }, "Formule mensuelle\xA0: L\u2019Abonnement est conclu pour une dur\xE9e d\u2019un (1) mois \xE0 compter de sa Date d\u2019activation. La "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3596
  }, "date d\u2019\xE9ch\xE9ance de l\u2019Abonnement est indiqu\xE9e dans la rubrique \xAB Mon Compte \xBB."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3629
  }, "A d\xE9faut de r\xE9siliation avant la date d\u2019\xE9ch\xE9ance mensuelle, l\u2019Abonnement est tacitement reconduit par p\xE9riodes "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3662
  }, "successives d\u2019un (1) mois. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3695
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3728
  }, "Formule annuelle\xA0: L\u2019Abonnement est conclu pour une dur\xE9e d\u2019un (1) an \xE0 compter de sa Date d\u2019activation. La date "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3761
  }, "d\u2019\xE9ch\xE9ance de l\u2019Abonnement est indiqu\xE9e dans la rubrique \xAB Mon Compte \xBB."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3794
  }, "A d\xE9faut de r\xE9siliation avant la date d\u2019\xE9ch\xE9ance annuelle, l\u2019Abonnement est tacitement reconduit par p\xE9riodes "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3827
  }, "successives d\u2019un (1) an."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3860
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3893
  }, "Formule ++annuelle\xA0: L\u2019Abonnement est conclu pour une dur\xE9e d\u2019un (1) an \xE0 compter de sa Date d\u2019activation. La "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3926
  }, "date d\u2019\xE9ch\xE9ance de l\u2019Abonnement est indiqu\xE9e dans la rubrique \xAB Mon Compte \xBB."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3959
  }, "A d\xE9faut de r\xE9siliation avant la date d\u2019\xE9ch\xE9ance annuelle, l\u2019Abonnement est tacitement reconduit par p\xE9riodes "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3992
  }, "successives d\u2019un (1) an."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4025
  }, "HooPow se r\xE9serve le droit de modifier, ajouter ou retirer des Formules \xE0 tout moment. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4058
  }), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4091
  }, "Article 6\xA0: P\xE9riode d\u2019essai"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4124
  })), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4157
  }, "L\u2019Abonnement peut d\xE9buter par une p\xE9riode d\u2019essai (ci-apr\xE8s la \xAB\xA0P\xE9riode d\u2019essai\xA0\xBB), dont la dur\xE9e est sp\xE9cifi\xE9e au "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4190
  }, "moment de la souscription par l\u2019Abonn\xE9. Cette P\xE9riode d\u2019essai est destin\xE9e aux nouveaux Abonn\xE9s et est soumise "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4223
  }, "aux pr\xE9sentes CGA. HooPow se r\xE9serve le droit, \xE0 son enti\xE8re discr\xE9tion, de d\xE9terminer la dur\xE9e de la P\xE9riode "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4256
  }, "d\u2019essai et l\u2019\xE9ligibilit\xE9 de l\u2019Abonn\xE9 \xE0 cette P\xE9riode d\u2019essai. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4289
  }, "Pendant cette P\xE9riode d\u2019essai, l\u2019Abonn\xE9 peut \xE0 tout moment r\xE9silier son Abonnement, dans les conditions pr\xE9vues "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4322
  }, "\xE0 l\u2019article 7.2. Au terme de la P\xE9riode d\u2019essai, l\u2019Abonn\xE9 sera automatiquement pr\xE9lev\xE9 du montant de "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4355
  }, "l\u2019Abonnement."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4388
  }), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4421
  }, "Article 7 : Modalit\xE9s de r\xE9siliation"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4454
  })), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4487
  }, "7.1 Droit de r\xE9tractation"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4520
  }, "Conform\xE9ment aux dispositions de l\u2019article L. 121-21-8 du Code de la Consommation, l\u2019Abonn\xE9 reconna\xEEt et "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4553
  }, "accepte express\xE9ment (i) que la fourniture du Service commence imm\xE9diatement apr\xE8s la validation de son "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4586
  }, "inscription au Service soit avant la fin du d\xE9lai de quatorze (14) jours francs pr\xE9vu par le Code de la Consommation "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4619
  }, "et (ii) reconna\xEEt et accepte en cons\xE9quence de ne pas b\xE9n\xE9ficier du droit de r\xE9tractation li\xE9 \xE0 la vente en ligne ou \xE0 "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4652
  }, "distance. En cons\xE9quence, aucune demande de r\xE9tractation, d\u2019annulation ou de remboursement ne sera recevable "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4685
  }, "pour la p\xE9riode souscrite."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4718
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4751
  }, "7.2 R\xE9siliation"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4784
  }, "7.2.1 Par l\u2019Abonn\xE9"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4817
  }, "La r\xE9siliation de l\u2019Abonnement se fait, sans frais, depuis l\u2019espace \xAB Mon Compte \xBB accessible sur le Site \xE0 la "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4850
  }, "rubrique \xAB Annuler mon abonnement \xBB."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4883
  }, "La r\xE9siliation prend effet \xE0 la date d\u2019\xE9ch\xE9ance de l\u2019Abonnement en cours et l\u2019Abonn\xE9 reste redevable du montant "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4916
  }, "restant du jusqu\u2019\xE0 cette date. Si l\u2019Abonn\xE9 b\xE9n\xE9ficie d\u2019une P\xE9riode d\u2019essai, la r\xE9siliation prend effet \xE0 la date de "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4949
  }, "r\xE9siliation de la P\xE9riode d\u2019essai."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4982
  }, "Les paiements sont non remboursables et nous n&apos;accordons aucun remboursement ou cr\xE9dit pour les p\xE9riodes "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5015
  }, "d&apos;utilisation partielle, ou pour tout contenu HooPow non regard\xE9. Si vous r\xE9siliez votre abonnement, votre compte "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5048
  }, "sera automatiquement cl\xF4tur\xE9 \xE0 l&apos;issue de votre p\xE9riode de facturation en cours. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5081
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5114
  }, "7.2.2 Par HooPow"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5147
  }, "HooPow dispose de la facult\xE9 de r\xE9silier et/ou suspendre le Service de plein droit en cas :"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5180
  }, "de non-paiement de l\u2019Abonnement HooPow par l\u2019Abonn\xE9 ;"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5213
  }, "d\u2019absence de mise \xE0 jour des informations relatives \xE0 la carte bancaire \xE0 l\u2019\xE9ch\xE9ance de sa dur\xE9e de validit\xE9\xA0;"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5246
  }, "d\u2019agissements contrevenant aux dispositions du Code de la propri\xE9t\xE9 intellectuelle ;"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5279
  }, "plus g\xE9n\xE9ralement, en cas de manquements de l\u2019Abonn\xE9 \xE0 l\u2019une quelconque des obligations qui lui incombent en "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5312
  }, "vertu des pr\xE9sentes CGA."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5345
  }, "Cette r\xE9siliation entrainera la d\xE9sactivation imm\xE9diate de l\u2019Abonnement au Service, sans droit \xE0 indemnit\xE9 ni \xE0 "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5378
  }, "remboursement."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5411
  }), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5444
  }, "Article 8 : Prix et conditions de paiement"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5477
  })), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5510
  }, "8.1 Prix"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5543
  }, "L\u2019Abonnement implique le paiement par l\u2019Abonn\xE9 d\u2019un prix mensuel ou annuel forfaitaire selon la Formule "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5576
  }, "souscrite par l\u2019Abonn\xE9."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5609
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5642
  }, "Les prix applicables aux Abonnements sont indiqu\xE9s toutes taxes comprises et ne comprennent pas les co\xFBts des "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5675
  }, "services souscrits aupr\xE8s de tiers, notamment les fournisseurs d\u2019acc\xE8s Internet. Les dits prix sont indiqu\xE9s \xE0 "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5708
  }, "l\u2019Abonn\xE9 sur le Site pr\xE9alablement \xE0 sa souscription."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5741
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5774
  }, "Toute modification du prix mensuel tarifaire sera port\xE9e \xE0 la connaissance de l\u2019Abonn\xE9 au moins un (1) mois avant "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5807
  }, "son entr\xE9e en vigueur. Dans ce cas, l\u2019Abonn\xE9 aura la facult\xE9 de r\xE9silier son Abonnement, dans les conditions "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5840
  }, "pr\xE9vues \xE0 l\u2019article 7.2."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5873
  }, "Toute modification du prix annuel tarifaire sera port\xE9e \xE0 la connaissance de l\u2019Abonn\xE9 au moins un (1) mois avant le "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5906
  }, "renouvellement de son Abonnement. Dans ce cas, l\u2019Abonn\xE9 aura la facult\xE9 de r\xE9silier son Abonnement, dans les "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5939
  }, "conditions pr\xE9vues \xE0 l\u2019article 7.2."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5972
  }, "Des tarifs promotionnels pourront \xEAtre propos\xE9s \xE0 la discr\xE9tion de HooPow, pendant une dur\xE9e limit\xE9e. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6005
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6038
  }, "8.2 Modalit\xE9s de paiement"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6071
  }, "Pour la Formule mensuelle\xA0:"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6104
  }, "Tout Abonnement est payable d\u2019avance, chaque mois, par paiement r\xE9current par carte bancaire, via un acc\xE8s "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6137
  }, "s\xE9curis\xE9 depuis le Site. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6170
  }, "Pour les Abonn\xE9s b\xE9n\xE9ficiant d\u2019une P\xE9riode d\u2019essai et sauf r\xE9siliation de leur part, l\u2019Abonnement est "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6203
  }, "automatiquement poursuivi \xE0 l\u2019expiration de la P\xE9riode d\u2019essai\xA0et l\u2019Abonn\xE9 se verra pr\xE9lever le prix mensuel "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6236
  }, "forfaitaire de l\u2019Abonnement choisi. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6269
  }, "Le premier d\xE9bit est r\xE9alis\xE9 le jour de la souscription \xE0 l\u2019Abonnement ou, pour les Abonn\xE9s en P\xE9riode d\u2019essai, le "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6302
  }, "jour suivant l\u2019expiration de ladite P\xE9riode d\u2019essai. \xA0"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6335
  }, "Les d\xE9bits mensuels suivants sont r\xE9alis\xE9s le 1er jour de chaque nouvelle p\xE9riode mensuelle."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6368
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6401
  }, "L\u2019Abonn\xE9 reconna\xEEt que la communication des informations relatives \xE0 sa carte bancaire vaut autorisation de d\xE9bit "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6434
  }, "mensuel de son compte bancaire par l\u2019interm\xE9diaire de son num\xE9ro de carte bancaire au profit de HooPow, \xE0 due "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6467
  }, "concurrence du montant mensuel de la Formule choisie."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6500
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6533
  }, "L\u2019Abonn\xE9 est tenu de mettre \xE0 jour et/ou modifier ses coordonn\xE9es bancaires via son Compte, rubrique \xAB changer "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6566
  }, "mon mode de paiement \xBB, notamment dans le cas o\xF9 la validit\xE9 des coordonn\xE9es arrive \xE0 \xE9ch\xE9ance."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6599
  }, "Pour les Formules annuelle et ++annuelle :"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6632
  }, "Tout Abonnement est payable d\u2019avance, chaque ann\xE9e, par paiement r\xE9current par carte bancaire, via un acc\xE8s "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6665
  }, "s\xE9curis\xE9 depuis le Site. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6698
  }, "Pour les Abonn\xE9s b\xE9n\xE9ficiant d\u2019une P\xE9riode d\u2019essai et sauf r\xE9siliation de leur part, l\u2019Abonnement est "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6731
  }, "automatiquement poursuivi \xE0 l\u2019expiration de la P\xE9riode d\u2019essai\xA0et l\u2019Abonn\xE9 se verra pr\xE9lever le prix annuel "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6764
  }, "forfaitaire de la Formule choisie. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6797
  }, "Le premier d\xE9bit est r\xE9alis\xE9 le jour de la souscription \xE0 l\u2019Abonnement ou, pour les Abonn\xE9s en P\xE9riode d\u2019essai, le "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6830
  }, "jour suivant l\u2019expiration de ladite P\xE9riode d\u2019essai. \xA0"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6863
  }, "Les d\xE9bits annuels suivants sont r\xE9alis\xE9s le 1er jour de chaque nouvelle p\xE9riode annuelle."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6896
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6929
  }, "L\u2019Abonn\xE9 reconna\xEEt que la communication des informations relatives \xE0 sa carte bancaire vaut autorisation de d\xE9bit "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6962
  }, "annuel de son compte bancaire par l\u2019interm\xE9diaire de son num\xE9ro de carte bancaire au profit de HooPow, \xE0 due "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6995
  }, "concurrence du montant annuel de la Formule choisie."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7028
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7061
  }, "L\u2019Abonn\xE9 est tenu de mettre \xE0 jour et/ou modifier ses coordonn\xE9es bancaires via son Compte, rubrique \xAB changer "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7094
  }, "mon mode de paiement \xBB, notamment dans le cas o\xF9 la validit\xE9 des coordonn\xE9es arrive \xE0 \xE9ch\xE9ance."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7127
  })), /*#__PURE__*/React.createElement("text", {
    id: "Article_9_:_Donn\\xE9es_personnelles_9.1_Protection_et_traitement_de_donn\\xE9es_\\xE0_caract\\xE8re_personnel_HooPow_s_engage_dans_le_cadre_de_ses_activit\\xE9s_et_conform\\xE9ment_\\xE0_la_l\\xE9gislation_en_vigueur_en_France_et_au_sein_de_l_Union_Europ\\xE9enne_\\xE0_assurer_la_protection_",
    "data-name": "Article 9 : Donn\\xE9es personnelles 9.1 Protection et traitement de donn\\xE9es \\xE0 caract\\xE8re personnel HooPow s\\u2019engage, dans le cadre de ses activit\\xE9s et conform\\xE9ment \\xE0 la l\\xE9gislation en vigueur en France et au sein de l\\u2019Union Europ\\xE9enne, \\xE0 assurer la protection,",
    transform: "translate(125 7464)",
    fontSize: 32,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 32
  }, "Article 9 : Donn\xE9es personnelles"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Avenir-Medium, Avenir",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 65
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 98
  }, "9.1 Protection et traitement de donn\xE9es \xE0 caract\xE8re personnel"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 131
  }, "HooPow s\u2019engage, dans le cadre de ses activit\xE9s et conform\xE9ment \xE0 la l\xE9gislation en vigueur en France et au sein "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 164
  }, "de l\u2019Union Europ\xE9enne, \xE0 assurer la protection, la confidentialit\xE9 et la s\xE9curit\xE9 des donn\xE9es \xE0 caract\xE8re personnel "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 197
  }, "des utilisateurs de ses services, ainsi qu\u2019\xE0 respecter leur vie priv\xE9e."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 230
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 263
  }, "La pr\xE9sente clause vous informe sur la fa\xE7on dont HooPow et ses sous-traitants, traitent vos donn\xE9es personnelles."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 296
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 329
  }, "Quelles donn\xE9es sont collect\xE9es par HooPow et ses sous-traitants ?"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 362
  }, "Dans le cadre de la souscription et de l\u2019utilisation du Service et du Site, HooPow traite :"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 395
  }, "des donn\xE9es d\u2019identification : nom, pr\xE9nom, adresse email, mot de passe identifiant technique client."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 428
  }, "des donn\xE9es financi\xE8res : informations relatives \xE0 votre carte bancaire et votre historique de paiement (par "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 461
  }, "exemple, information indiquant qu\u2019il y a eu un refus de paiement)."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 494
  }, "des donn\xE9es relatives \xE0 votre activit\xE9 sur le Service et le Site : journal de connexion, donn\xE9es de navigation, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 527
  }, "donn\xE9es de consommation des contenus (dont donn\xE9es de profils \xE9tablis sur la base de l\u2019utilisation du Service), "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 560
  }, "demande d\u2019acc\xE8s au Service depuis la France ou hors de France, donn\xE9es techniques correspondant aux terminaux "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 593
  }, "de r\xE9ception."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 626
  }, "le d\xE9tail de nos \xE9changes avec vous (par e-mail), lorsque vous nous contactez pour signaler un probl\xE8me, poser "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 659
  }, "une question ou encore lorsqu\u2019HooPow vous contacte pour vous informer sur le contenu du Service, des "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 692
  }, "\xE9v\xE8nements ou des offres commerciales. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 725
  }, "Pour quelle dur\xE9e vos donn\xE9es sont-elles collect\xE9es ?"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 758
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 791
  }, "Vos donn\xE9es personnelles sont strictement confidentielles et conserv\xE9es pour une dur\xE9e qui varie en fonction des "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 824
  }, "finalit\xE9s expos\xE9es au pr\xE9sent article. Par exemple, vos nom, pr\xE9nom et adresse email sont conserv\xE9s pour une "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 857
  }, "dur\xE9e maximale de 3 ans apr\xE8s la fin de votre relation commerciale avec HooPow. Vos donn\xE9es seront ensuite "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 890
  }, "archiv\xE9es avec un acc\xE8s restreint pour une dur\xE9e suppl\xE9mentaire pour r\xE9pondre \xE0 des obligations l\xE9gales ou "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 923
  }, "r\xE9glementaires (par exemple, les factures vous concernant doivent \xEAtre conserv\xE9es au minimum pendant 10 ans). "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 956
  }, "Pass\xE9 ce d\xE9lai, vos donn\xE9es seront supprim\xE9es ou anonymis\xE9es."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 989
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1022
  }, "Pourquoi HooPow traite vos donn\xE9es ?"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1055
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1088
  }, "(a) HooPow traite vos donn\xE9es dans le cadre de l\u2019ex\xE9cution d\u2019un contrat (votre Abonnement au Service) pour les "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1121
  }, "finalit\xE9s suivantes :"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1154
  }, "g\xE9rer l\u2019identit\xE9 de l\u2019Abonn\xE9 et l\u2019authentifier,"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1187
  }, "g\xE9rer l\u2019Abonnement au Service,"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1220
  }, "facturer et encaisser les paiements li\xE9s \xE0 l\u2019Abonnement,"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1253
  }, "recouvrer les factures,"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1286
  }, "g\xE9rer les caract\xE9ristiques et options du contrat (en fonction de l\u2019offre commerciale),"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1319
  }, "g\xE9rer les fonctionnalit\xE9s du Service "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1352
  }, "assurer le support client."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1385
  }, "(b) HooPow r\xE9alise \xE9galement des traitements de donn\xE9es sur d\u2019autres bases que la stricte ex\xE9cution de contrats. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1418
  }, "Dans ce cas, HooPow s\u2019assure de fonder le traitement sur un int\xE9r\xEAt l\xE9gitime ou d\u2019avoir pr\xE9alablement recueilli "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1451
  }, "votre consentement, que vous pourrez retirer \xE0 tout moment."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1484
  }, "A cet effet, les finalit\xE9s poursuivies par OCS sont les suivantes :"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1517
  }, "\xE9valuer l\u2019audience du Service et du Site selon les diff\xE9rents usages des Abonn\xE9s,"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1550
  }, "am\xE9liorer le Service et le Site en fonction des pr\xE9f\xE9rences, besoins et usages des Abonn\xE9s,"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1583
  }, "adresser des newsletters et toute information relative aux contenus et services propos\xE9s,"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1616
  }, "organiser des op\xE9rations de marketing direct,"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1649
  }, "organiser des animations commerciales,"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1682
  }, "proposer de participer \xE0 des jeux concours,"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1715
  }, "sonder les clients,"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1748
  }, "faire b\xE9n\xE9ficier \xE0 tout nouvel Abonn\xE9 d\u2019une offre promotionnelle,"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1781
  }, "pr\xE9venir toute utilisation abusive de la P\xE9riode d\u2019essai,"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1814
  }, "faciliter la r\xE9activation de l\u2019Abonnement,"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1847
  }, "lutter contre la fraude."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1880
  }, "Vos donn\xE9es sont conserv\xE9es pour la dur\xE9e n\xE9cessaire \xE0 l\u2019accomplissement des finalit\xE9s mentionn\xE9es ci-dessus."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1913
  }, "(c) HooPow traite \xE9galement vos donn\xE9es pour r\xE9pondre \xE0 ses obligations l\xE9gales ou r\xE8glementaires et conserve "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1946
  }, "les donn\xE9es requises pour \xEAtre en mesure d\u2019y r\xE9pondre. Par exemple, conform\xE9ment aux dispositions l\xE9gales en "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1979
  }, "vigueur, g\xE9rer les r\xE9clamations ou encore conserver les pi\xE8ces justifiant une transaction commerciales, telles que "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2012
  }, "des factures."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2045
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2078
  }, "Quels sont les destinataires de vos donn\xE9es ?"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2111
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2144
  }, "Afin de vous d\xE9livrer le Service, HooPow s\u2019appuie sur l\u2019expertise de ses sous-traitants. Dans ce cadre, les donn\xE9es "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2177
  }, "utiles aux finalit\xE9s ci-dessus sont transmises \xE0 nos sous-traitants en charge de\xA0:"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2210
  }, "- l\u2019h\xE9bergement des portails d\u2019acc\xE8s au Service,"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2243
  }, "- la facturation et le paiement du Service,"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2276
  }, "- la gestion du support client,"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2309
  }, "- l\u2019envoi de newsletters et de propositions commerciales, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2342
  }, "- l\u2019analyse des usages des Abonn\xE9s et des op\xE9rations marketing, et"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2375
  }, "- la v\xE9rification que l\u2019utilisation du Service par l\u2019Abonn\xE9 a lieu en France ou, en application du R\xE8glement (UE) "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2408
  }, "2017/1128 relatif \xE0 la portabilit\xE9 transfrontali\xE8re des services de contenu en ligne dans le march\xE9 int\xE9rieur "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2441
  }, "portabilit\xE9 des contenus, dans un autre Etat de l\u2019Espace Economique Europ\xE9en."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2474
  }, "Vos donn\xE9es sont-elles trait\xE9es hors de l\u2019Union Europ\xE9enne ?"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2507
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2540
  }, "Afin de vous d\xE9livrer un Service de qualit\xE9, HooPow s\u2019appuie sur l\u2019expertise de ses sous-traitants, dont certains "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2573
  }, "traitent vos donn\xE9es en dehors de l\u2019Union Europ\xE9enne (exemple\xA0: les prestations de facturation et de support "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2606
  }, "client). "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2639
  }, "Dans ce cadre, HooPow s\xE9lectionne ses sous-traitants avec la plus grande vigilance et prend les dispositions "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2672
  }, "n\xE9cessaires pour que vos donn\xE9es soient trait\xE9es de mani\xE8re s\xE9curis\xE9e. Ainsi, HooPow s\u2019assure, que le traitement "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2705
  }, "de ces donn\xE9es par ses sous-traitants soit effectu\xE9 en conformit\xE9 avec les r\xE9glementations applicables et qu\u2019ils "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2738
  }, "agissent uniquement sur instruction d\u2019HooPow, dans le cadre de l\u2019ex\xE9cution des prestations qu\u2019HooPow leur "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2771
  }, "confie. HooPow s\u2019assure \xE9galement que le transfert des donn\xE9es personnelles \xE0 ces sous-traitants soit op\xE9r\xE9 en "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2804
  }, "vertu d\u2019une d\xE9cision d\u2019ad\xE9quation de la Commission europ\xE9enne vers un pays assurant un niveau de protection "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2837
  }, "ad\xE9quat (lien CNIL) et, si les sous-traitants concern\xE9s ne sont pas situ\xE9s dans un pays offrant une protection "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2870
  }, "ad\xE9quate, que le transfert des donn\xE9es personnelles soit encadr\xE9 par des garanties appropri\xE9es et en particulier, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2903
  }, "des dispositions contractuelles, techniques et organisationnelles adapt\xE9es, comme les clauses contractuelles types "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2936
  }, "de la Commission europ\xE9enne qui permettent de garantir un niveau de protection suffisant de la vie priv\xE9e et des "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2969
  }, "droits fondamentaux des personnes.\xA0"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3002
  }, "Comment HooPow assure la s\xE9curit\xE9 de vos donn\xE9es ?"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3035
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3068
  }, "HooPow a mis en place des mesures techniques et organisationnelles appropri\xE9es pour prot\xE9ger les donn\xE9es "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3101
  }, "personnelles contre leur destruction, leur perte, leur alt\xE9ration ou leur divulgation non autoris\xE9e."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3134
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3167
  }, "De fa\xE7on g\xE9n\xE9rale, HooPow s\u2019efforce de prot\xE9ger les donn\xE9es \xE0 caract\xE8re personnel en tenant compte de la "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3200
  }, "sensibilit\xE9 des informations en cause et des risques potentiels induits par une fuite de donn\xE9es. Nous mettons en "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3233
  }, "\u0153uvre tout moyen utile afin de garantir la confidentialit\xE9, l\u2019int\xE9grit\xE9, la disponibilit\xE9 et la r\xE9silience de vos donn\xE9es, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3266
  }, "veillons \xE0 stocker les donn\xE9es vous concernant dans des syst\xE8mes d\u2019information offrant un niveau de s\xE9curit\xE9 "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3299
  }, "appropri\xE9, dont l\u2019acc\xE8s est prot\xE9g\xE9, restreint et enregistr\xE9, concluons des accords de confidentialit\xE9 stricts avec "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3332
  }, "nos parties prenantes."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3365
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3398
  }, "HooPow s\u2019assure par ailleurs que tous les membres du personnel et toutes les personnes qui interviennent dans le "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3431
  }, "traitement des donn\xE9es respectent l\u2019ensemble des r\xE8gles relatives \xE0 la protection des donn\xE9es et s\u2019engagent \xE0 "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3464
  }, "maintenir confidentielles les donn\xE9es trait\xE9es."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3497
  }, "Comment exercer vos droits ?"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3530
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3563
  }, "Conform\xE9ment \xE0 la r\xE9glementation applicable, vous disposez d\u2019un droit d\u2019acc\xE8s, de rectification et de suppression "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3596
  }, "des donn\xE9es qui vous concernent. Vous pouvez demander la portabilit\xE9 de ces donn\xE9es. Vous avez \xE9galement le "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3629
  }, "droit de vous opposer aux traitements ou d\u2019en demander la limitation. Vous pouvez \xE9mettre des directives sur la "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3662
  }, "conservation, la suppression ou la communication de vos donn\xE9es personnelles apr\xE8s votre d\xE9c\xE8s."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3695
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3728
  }, "Pour exercer vos droits sur les traitements des donn\xE9es personnelles qui vous concernent, vous pouvez, nous "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3761
  }, "contacter par email \xE0 BDouin@hoo-pow.com."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3794
  }, "Si les r\xE9ponses d\u2019HooPow ne vous avaient pas donn\xE9 enti\xE8re satisfaction, vous avez la possibilit\xE9 d\u2019introduire une "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3827
  }, "r\xE9clamation aupr\xE8s de la Commission Nationale de l\u2019Informatique et des Libert\xE9s (CNIL), autorit\xE9 de contr\xF4le en "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3860
  }, "charge du respect des obligations en mati\xE8re de donn\xE9es \xE0 caract\xE8re personnel en France."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3893
  }, "9.2 Les cookies utilis\xE9s sur le Site"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3926
  }, "En tant qu\u2019Utilisateur, lors de votre navigation sur le Site, des cookies sont d\xE9pos\xE9s sur votre ordinateur, votre "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3959
  }, "mobile (bien que non support\xE9e) ou votre tablette. Ces cookies sont destin\xE9s \xE0 faciliter la navigation sur le Site et "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3992
  }, "\xE0 en \xE9tudier les usages notamment pour des finalit\xE9s de statistiques."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4025
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4058
  }, "Qu\u2019est-ce qu\u2019un cookie ?"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4091
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4124
  }, "Un cookie (ou t\xE9moin de connexion) est un fichier texte susceptible d\u2019\xEAtre enregistr\xE9, sous r\xE9serve de vos choix, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4157
  }, "dans un espace d\xE9di\xE9 du disque dur de votre terminal (ordinateur, tablette \u2026) \xE0 l\u2019occasion de la consultation d\u2019un "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4190
  }, "service en ligne gr\xE2ce \xE0 votre logiciel de navigation. Il est transmis par le serveur d\u2019un site internet \xE0 votre "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4223
  }, "navigateur."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4256
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4289
  }, "A chaque cookie est attribu\xE9 un identifiant anonyme. Le fichier cookie permet \xE0 son \xE9metteur d\u2019identifier le "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4322
  }, "terminal dans lequel il est enregistr\xE9 pendant la dur\xE9e de validit\xE9 ou d\u2019enregistrement du cookie concern\xE9."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4355
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4388
  }, "Un cookie ne permet pas de remonter \xE0 une personne physique. Les informations r\xE9colt\xE9es par l\u2019interm\xE9diaire de "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4421
  }, "ces cookies restent anonymes."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4454
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4487
  }, "Comment les utilisons-nous ?"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4520
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4553
  }, "Les cookies d\xE9pos\xE9s par HooPow ont plusieurs utilit\xE9s en fonction de leur cat\xE9gorie :"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4586
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4619
  }, "* Les cookies techniques :"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4652
  }, "Il s\u2019agit des cookies de navigation n\xE9cessaires \xE0 garantir la qualit\xE9 des services HooPow. Ils nous permettent de "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4685
  }, "suivre les performances de notre Site et de d\xE9tecter des probl\xE8mes afin de r\xE9duire autant que possible la g\xEAne "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4718
  }, "occasionn\xE9e pour nos utilisateurs."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4751
  }, "\xA0* Les cookies statistiques :"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4784
  }, "Ils nous permettent de suivre les performances de notre Site et d\u2019avoir des statistiques d\u2019audiences utilisant nos "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4817
  }, "services (ex : nombre de visites, pages consult\xE9es, temps pass\xE9 sur le site, r\xE9gion de connexion, type d\u2019appareil "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4850
  }, "utilis\xE9...). Les donn\xE9es recueillies \xE0 des fins statistiques font l&apos;objet d&apos;un traitement anonymis\xE9 pour des mesures "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4883
  }, "d&apos;audience exclusivement."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4916
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4949
  }, "HooPow ne d\xE9pose pas de cookie publicitaire."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4982
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5015
  }, "Vos droits"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5048
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5081
  }, "Vous pouvez vous opposer \xE0 l&apos;installation de ces cookies \xE0 tout moment selon la proc\xE9dure d\xE9crite ci-dessous. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5114
  }, "Nous vous informons que le fait de s&apos;opposer \xE0 l&apos;installation de ces cookies sur votre terminal de r\xE9ception peut "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5147
  }, "venir alt\xE9rer et emp\xEAcher votre navigation et utilisation du site hoo-pow.com."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5180
  }, "Comment s\u2019opposer aux cookies statistiques utilis\xE9s sur le Site ?"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5213
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5246
  }, "Vous pouvez vous opposer \xE0 l&apos;enregistrement de cookies en configurant votre navigateur de la mani\xE8re suivante :"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5279
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5312
  }, "* Sur Internet Explorer"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5345
  }, "1. Allez dans Outils &gt; Options Internet."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5378
  }, "2. Cliquez sur l&apos;onglet Confidentialit\xE9."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5411
  }, "3. Cliquez sur le bouton Avanc\xE9, cochez la case &quot;Refuser&quot; sur la partie Cookies internes et sur la partie Cookies "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5444
  }, "tierce partie."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5477
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5510
  }, "* Sur Firefox"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5543
  }, "1. En haut de la fen\xEAtre de Firefox, cliquez sur le bouton Firefox ou Outils (sous Windows XP), puis s\xE9lectionnez "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5576
  }, "Options."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5609
  }, "2. S\xE9lectionnez le panneau Vie priv\xE9e et s\xE9curit\xE9."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5642
  }, "3. Dans la zone Cookies et donn\xE9es de sites, param\xE9trez la cat\xE9gorie Accepter les cookies et les donn\xE9es de sites "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5675
  }, "comme suit\xA0:"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5708
  }, "- Les conserver jusqu\u2019\xE0\xA0: soit Leur expiration, soit La fermeture de Firefox, et"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5741
  }, "- Accepter les cookies tiers et les donn\xE9es de sites tiers\xA0: soit Toujours, soit Depuis les sites visit\xE9s, soit Jamais."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5774
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5807
  }, "* Sur Chrome"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5840
  }, "1. Cliquez sur Options ou l&apos;ic\xF4ne repr\xE9sentant une cl\xE9 \xE0 molette qui est situ\xE9e dans la barre d&apos;outils du navigateur."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5873
  }, "2. S\xE9lectionnez Param\xE8tres."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5906
  }, "3. Cliquez sur Param\xE8tres avanc\xE9s."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5939
  }, "4. Dans la section Confidentialit\xE9 et s\xE9curit\xE9, cliquez sur le bouton Param\xE8tres du site."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5972
  }, "5. Dans la section Cookies et donn\xE9es du site, vous pouvez activer les param\xE8tres Effacer les cookies et les "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6005
  }, "donn\xE9es de site en quittant Chrome et Bloquer les cookies tiers."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6038
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6071
  }, "* Sur Safari"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6104
  }, "1. Allez dans R\xE9glages, puis Pr\xE9f\xE9rences."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6137
  }, "2. Cliquez sur l&apos;onglet Confidentialit\xE9."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6170
  }, "3. Dans la zone Bloquer les cookies, cochez la case Toujours."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6203
  }, "* Sur Op\xE9ra"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6236
  }, "1. Allez dans Param\xE8tres, puis Param\xE8tres avanc\xE9s, puis Param\xE8tres du site et Cookies et donn\xE9es du site."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6269
  }, "2. Dans la zone Confidentialit\xE9 et s\xE9curit\xE9, vous pouvez activer les param\xE8tres Effacer les cookies et les donn\xE9es "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6302
  }, "de site lorsque vous quittez Opera et Bloquer les cookies tiers."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6335
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6368
  })), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6401
  }, "Article 10 : Propri\xE9t\xE9 intellectuelle"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Avenir-Medium, Avenir",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6434
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6467
  }, "HooPow est titulaire de l\u2019ensemble des droits de propri\xE9t\xE9 intellectuelle du Service et du Site associ\xE9. Le contenu "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6500
  }, "du Site est la propri\xE9t\xE9 exclusive de la soci\xE9t\xE9 HooPow, titulaire de l\u2019ensemble des droits y aff\xE9rents, marques, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6533
  }, "logo, nom, etc. (ci-apr\xE8s d\xE9sign\xE9s les \xAB El\xE9ments \xBB)."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6566
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6599
  }, "Toute reproduction, totale ou partielle, modification ou utilisation des El\xE9ments, et plus g\xE9n\xE9ralement des autres "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6632
  }, "droits de propri\xE9t\xE9 intellectuelle attach\xE9s \xE0 HooPow pour quelque motif et sur quelque support que ce soit, sans "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6665
  }, "accord expr\xE8s et pr\xE9alable de la soci\xE9t\xE9 HooPow, est strictement interdite."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6698
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6731
  }, "L\u2019utilisation et l\u2019acc\xE8s au Service ne conf\xE8re aucun droit \xE0 l\u2019Abonn\xE9 sur quelque \xE9l\xE9ment que ce soit."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6764
  }, "Le Service HooPow, y compris l&apos;ensemble du contenu fourni, est prot\xE9g\xE9 par les lois et les trait\xE9s sur le droit "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6797
  }, "d&apos;auteur, les marques d\xE9pos\xE9es, le secret commercial et la propri\xE9t\xE9 intellectuelle."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6830
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6863
  }, "Les droits d&apos;auteur li\xE9s aux contenus disponibles sur le Service sont d\xE9tenus par OP2A Partners Luxembourg. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6896
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6929
  }, "Si vous n&apos;avez pas obtenu notre autorisation de le faire, veuillez ne pas utiliser les marques de HooPow comme si "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6962
  }, "elles vous appartenaient ou de toute autre mani\xE8re qui impliquerait un parrainage ou une approbation de la part "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6995
  }, "de HooPow."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7028
  }, "Tout produit marqu\xE9 du nom ou du logo HooPow repr\xE9sente l&apos;image de HooPow. \xC0 moins que vous ne fassiez "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7061
  }, "partie de nos titulaires de licence, vous n&apos;\xEAtes pas autoris\xE9 \xE0 produire, vendre ou donner quoi que ce soit portant "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7094
  }, "notre nom ou notre logo."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7127
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7160
  }, "HooPow n&apos;accepte aucun contenu ou id\xE9e non sollicit\xE9s concernant du contenu HooPow, et se d\xE9gage de toute "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7193
  }, "responsabilit\xE9 quant aux similitudes entre son contenu ou sa programmation et les contenus ou les id\xE9es qui lui "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7226
  }, "sont transmis."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7259
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Article_11_:_Contenu_Le_contenu_de_HooPow_est_r\\xE9guli\\xE8rement_mis_\\xE0_jour._De_m\\xEAme_nous_testons_r\\xE9guli\\xE8rement_diff\\xE9rents_aspects_de_notre_service_notamment_notre_Site_nos_interfaces_utilisateur_nos_offres_promotionnelles_et_la_disponibilit\\xE9_du_contenu_Ho",
    "data-name": "Article 11 : Contenu Le contenu de HooPow est r\\xE9guli\\xE8rement mis \\xE0 jour. De m\\xEAme, nous testons r\\xE9guli\\xE8rement diff\\xE9rents aspects de notre service, notamment notre Site, nos interfaces utilisateur, nos offres promotionnelles et la disponibilit\\xE9 du contenu Ho",
    transform: "translate(125 14783)",
    fontSize: 32,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 32
  }, "Article 11 : Contenu"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Avenir-Medium, Avenir",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 65
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 98
  }, "Le contenu de HooPow est r\xE9guli\xE8rement mis \xE0 jour. De m\xEAme, nous testons r\xE9guli\xE8rement diff\xE9rents aspects de "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 131
  }, "notre service, notamment notre Site, nos interfaces utilisateur, nos offres promotionnelles et la disponibilit\xE9 du "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 164
  }, "contenu HooPow. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 197
  }, "Certains contenus HooPow peuvent \xEAtre t\xE9l\xE9charg\xE9s et stock\xE9s temporairement pour \xEAtre regard\xE9s hors ligne sur "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 230
  }, "certains appareils pris en charge (ci-apr\xE8s \xAB\xA0Titres hors ligne\xA0\xBB). Des limitations s\u2019appliquent, y compris des "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 263
  }, "restrictions sur le nombre de Titres hors ligne par compte, le nombre maximum d\u2019appareils sur lesquels peuvent "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 296
  }, "\xEAtre t\xE9l\xE9charg\xE9s des Titres hors ligne, la p\xE9riode au cours de laquelle vous devrez commencer la lecture des Titres "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 329
  }, "hors ligne et la dur\xE9e pendant laquelle les Titres hors ligne seront accessibles. Certains Titres hors ligne ne peuvent "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 362
  }, "pas \xEAtre regard\xE9s dans certains pays et si vous vous connectez dans un pays depuis lequel il n\u2019est pas possible de "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 395
  }, "regarder ce Titre hors ligne, celui-ci ne pourra pas \xEAtre regard\xE9 tant que vous vous trouverez dans ce pays."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 428
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 461
  }, "Vous vous engagez \xE0 ne pas archiver, reproduire, distribuer, modifier, afficher, ex\xE9cuter, publier, conc\xE9der, cr\xE9er "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 494
  }, "des \u0153uvres d\xE9riv\xE9es, vendre ou utiliser (sauf autorisation expresse mentionn\xE9e dans les pr\xE9sentes CGA) le "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 527
  }, "contenu et les informations du service HooPow (ou obtenus via celui-ci). Vous vous engagez \xE9galement \xE0 ne pas\xA0: "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 560
  }, "contourner, retirer, modifier, d\xE9sactiver, d\xE9truire ou faire \xE9chouer les protections du contenu dans le cadre du "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 593
  }, "service HooPow; utiliser des robots, des robots d\u2019indexation, des outils de moissonnage du Web ou d\u2019autres "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 626
  }, "m\xE9thodes automatis\xE9es pour acc\xE9der au Service; d\xE9compiler, faire de l\u2019ing\xE9nierie inverse ou d\xE9monter tout "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 659
  }, "logiciel, produit ou processus accessibles via le Service; ins\xE9rer tout code ou produit, ou manipuler le contenu du "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 692
  }, "Service de quelque fa\xE7on que ce soit\xA0; ou utiliser toute m\xE9thode d\u2019exploration, de collecte ou d\u2019extraction de "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 725
  }, "donn\xE9es. De m\xEAme, vous vous engagez \xE0 ne pas t\xE9l\xE9charger, afficher, envoyer par e-mail ou envoyer ou "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 758
  }, "transmettre de quelque fa\xE7on que ce soit n\u2019importe quel contenu en vue d\u2019interrompre, d\xE9truire ou restreindre la "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 791
  }, "fonctionnalit\xE9 de tout logiciel ou \xE9quipement informatique ou de t\xE9l\xE9communication associ\xE9s au Service, y compris "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 824
  }, "tout virus ou tout autre code, fichier ou programme informatiques. Nous nous r\xE9servons le droit de r\xE9silier ou de "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 857
  }, "restreindre votre utilisation de notre service si vous enfreignez les pr\xE9sentes CGA ou faites une utilisation ill\xE9gale "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 890
  }, "ou ill\xE9gitime du service."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 923
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 956
  }, "La qualit\xE9 d\u2019affichage du contenu HooPow peut varier d\u2019un appareil \xE0 l\u2019autre, et peut \xEAtre influenc\xE9e par diff\xE9rents "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 989
  }, "facteurs, dont votre localisation, la bande passante disponible et/ou la vitesse de votre connexion Internet. Le d\xE9lai "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1022
  }, "qui s\u2019\xE9coule avant de pouvoir regarder du contenu HooPow varie en fonction de plusieurs facteurs, notamment "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1055
  }, "votre localisation, la bande passante disponible au moment o\xF9 vous regardez le titre, le contenu choisi et la "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1088
  }, "configuration de votre appareil compatible avec HooPow."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1121
  })), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1154
  }, "Article 12 : Responsabilit\xE9 d\u2019HooPow"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Avenir-Medium, Avenir",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1187
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1220
  }, "HooPow ne saurait \xEAtre tenue responsable des dysfonctionnements ou de toutes interruptions dans la mise \xE0 "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1253
  }, "disposition du Service li\xE9s \xE0 ou r\xE9sultant d\u2019un cas de force majeure, tel que d\xE9fini par la jurisprudence."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1286
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1319
  }, "HooPow ne saurait \xEAtre tenue responsable d\u2019un quelconque dommage subi par l\u2019Abonn\xE9 d\xFB \xE0 une incompatibilit\xE9 "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1352
  }, "technique de ses \xE9quipements avec HooPow."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1385
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1418
  }, "De m\xEAme, HooPow ne saurait \xEAtre tenue responsable d\u2019une quelconque indisponibilit\xE9 d\u2019un ou plusieurs "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1451
  }, "programmes due \xE0 des facteurs ne d\xE9pendant pas d\u2019HooPow (tels que des raisons techniques ou \xE9ditoriales, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1484
  }, "l\u2019encombrement du r\xE9seau, une d\xE9faillance des fournisseurs d\u2019acc\xE8s \xE0 Internet, etc.)."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1517
  })), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1550
  }, "Article 13 : Nullit\xE9 - Invalidit\xE9"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1583
  }), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Avenir-Medium, Avenir",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1616
  }, "Si une ou plusieurs dispositions dans les pr\xE9sentes CGA devaient s\u2019av\xE9rer non valides, ill\xE9gales ou inex\xE9cutables, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1649
  }, "les dispositions restantes demeureront pleinement applicables et conserveront leurs effets."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1682
  })), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1715
  }, "Article 14\xA0: Modification des CGA"), /*#__PURE__*/React.createElement("tspan", {
    y: 1715,
    fontFamily: "Avenir-Medium, Avenir",
    fontWeight: 500
  }), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Avenir-Medium, Avenir",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1748
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1781
  }, "HooPow peut, de temps \xE0 autre, modifier les pr\xE9sentes CGA. Nous vous informerons au moins 30\xA0jours avant que "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1814
  }, "de telles modifications ne deviennent applicables."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1847
  })), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1880
  }, "Article 15 : Loi applicable"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1913
  }), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Avenir-Medium, Avenir",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1946
  }, "Les pr\xE9sentes CGA sont soumises au droit fran\xE7ais."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1979
  }, "Tout litige r\xE9sultant de la formation, de l\u2019interpr\xE9tation ou de l\u2019ex\xE9cution des pr\xE9sentes sera de la comp\xE9tence "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2012
  }, "exclusive des tribunaux fran\xE7ais.")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCgu);
export default __webpack_public_path__ + "static/media/cgu.250ef1ba.svg";
export { ForwardRef as ReactComponent };